import React from 'react';
import clsx from 'clsx';
import { Resource } from 'types';
import { lnfGray } from '../../styles/style-constants';
import { FONT_GSS_CURSIVE_BEG_WIDE, FONT_GSS_PRINT_WIDE } from 'themes/default';
import { makeStyles } from '@mui/styles';

type Props = {
  onClickItem: (character: Resource) => void;
  styleOverrides?: any;
  characters: Resource[];
  characterGroup: string;
  application: string;
} & any;

const appWidths = {
  LNF: '100%',
  WDT: '100%',
  WoodPieces: '100%'
};

const appHeights = {
  LNF: '50%',
  WDT: '50%',
  WoodPieces: '35%'
};

const CharacterList = ({
  characters,
  onClickItem,
  styleOverrides,
  application,
  characterGroup
}: Props) => {
  const { listElement, list, cursiveFont } = useStyles();

  const renderListElements = () =>
    characters.reduce((acc, character, index) => {
      const { character: char, characterType } = character.character;
      acc.push(
        <div
          id={char}
          key={index}
          className={clsx(
            listElement,
            characterType === 'cursive' && cursiveFont,
            styleOverrides && styleOverrides.listElement
          )}
          onClick={() => onClickItem(character)}
        >
          <img
            src={require(`assets/images/CharacterTile/LetterCards/${application}/${characterGroup}/${char}.png`)}
            alt={char}
            width={appWidths[application]}
            height={appHeights[application]}
          />
        </div>
      );
      return acc;
    }, []);

  return <div className={list}>{renderListElements()}</div>;
};

const useStyles = makeStyles(() => ({
  list: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    fontFamily: FONT_GSS_PRINT_WIDE,
    fontSize: '28px',
    userSelect: 'none',
    padding: '10px 10px 20px'
  },
  cursiveFont: {
    fontFamily: FONT_GSS_CURSIVE_BEG_WIDE,
    fontSize: '35px'
  },
  listElement: {
    cursor: 'pointer',
    padding: '10px',
    margin: '5px',
    width: '135px',
    height: '100%',
    transition: 'background-color 0.1s linear',
    '&:hover': {
      backgroundColor: lnfGray
    }
  }
}));

export default CharacterList;
